export default function LovstaWorld() {
  const lovstaWorldButtons = document.querySelectorAll('.js-lovsta-world');
  const lovstaWorldIsVisibleClass = 'lovsta-world--is-visible';
  const lovstaWorldButtonIsActiveClass = 'lovsta-world__button--is-active';

  window.innerWidth > 768 ?
    document.querySelector('.lovsta-world--is-navigation').setAttribute('aria-hidden', true) : document.querySelector('.lovsta-world--is-header-nav').setAttribute('aria-hidden', true);

  lovstaWorldButtons.forEach(button => {
    button.addEventListener('click', () => {
      toggleLovstaWorld(button);
    });
  });

  function toggleLovstaWorld(button) {
    let currentlovstaWorld = document.querySelector('.lovsta-world--is-' + button.dataset.content);

    if (currentlovstaWorld.classList.contains(lovstaWorldIsVisibleClass)) {
      button.classList.remove(lovstaWorldButtonIsActiveClass);
      currentlovstaWorld.classList.remove(lovstaWorldIsVisibleClass);
    } else {
      button.classList.add(lovstaWorldButtonIsActiveClass);
      currentlovstaWorld.classList.add(lovstaWorldIsVisibleClass);
    }
  };

  function closeLovstaWorld() {
    if (document.querySelector('.' + lovstaWorldButtonIsActiveClass)) {
      document.querySelector('.' + lovstaWorldButtonIsActiveClass).classList.remove(lovstaWorldButtonIsActiveClass);
      document.querySelector('.' + lovstaWorldIsVisibleClass).classList.remove(lovstaWorldIsVisibleClass); 
    }
  };

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.lovsta-world') && !e.target.closest('.js-lovsta-world')) {
      closeLovstaWorld();
    }
  });

  document.addEventListener('keydown', function (e) { e.key === 'Escape' && closeLovstaWorld()});
}
